"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Networks = __importStar(require("../lib/Networks"));
const Marketplaces = __importStar(require("../lib/Marketplaces"));
const whitelist_json_1 = __importDefault(require("./whitelist.json"));
const CollectionConfig = {
    testnet: Networks.polygonTestnet,
    mainnet: Networks.polygonMainnet,
    // The contract name can be updated using the following command:
    // yarn rename-contract NEW_CONTRACT_NAME
    // Please DO NOT change it manually!
    contractName: "DeadBirds",
    tokenName: "DeadBirds",
    tokenSymbol: "DDB",
    hiddenMetadataUri: "ipfs://bafkreiaseybgawhjot4qbktsr63grqklalkdxxy2gk4ihrv6mbsfctoojy",
    maxSupply: 2222,
    whitelistSale: {
        price: 0.5,
        maxMintAmountPerTx: 58,
        whitelistSupply: 2222
    },
    preSale: {
        price: 0.5,
        maxMintAmountPerTx: 1,
    },
    publicSale: {
        price: 0.5,
        maxMintAmountPerTx: 1,
    },
    contractAddress: "0x0aAD434F1d76058eDDF751261f99537bDa224470",
    walletConnectProjectId: "665d687852032cfc7d1c167792f3c74b",
    marketplaceIdentifier: "deadbirdsofficial",
    marketplaceConfig: Marketplaces.openSea,
    whitelistAddresses: whitelist_json_1.default,
    royaltyReceiver: "0x4af9CA5Fd841D2B04c59cf38290891ceEE9b8981",
    royaltyNumerator: "1000",
    treasury: "0xc2E5ba835c571a5f2306C31f961DF73D379eaEFe",
};
exports.default = CollectionConfig;
